import { render, staticRenderFns } from "./ConfigCoolSwitchBox.vue?vue&type=template&id=77fec26b&scoped=true&"
import script from "./ConfigCoolSwitchBox.vue?vue&type=script&lang=js&"
export * from "./ConfigCoolSwitchBox.vue?vue&type=script&lang=js&"
import style0 from "./ConfigCoolSwitchBox.vue?vue&type=style&index=0&id=77fec26b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fec26b",
  null
  
)

export default component.exports